import { Zap } from "@untitledui/icons";
import type { MouseEvent } from "react";
import { useTikTokAdsAuthUrl } from "@/api/tiktok-ads";
import { Button } from "@/components/base/buttons/button";
import { error } from "@/providers/ToastProvider";

type AuthoriseTikTokAdsButtonProps = {
  /** Extra handler run before opening the auth link — e.g. stopPropagation inside a clickable row. */
  onClick?: (event: MouseEvent) => void;
};

/** Shared "Authorise TikTok ads" CTA — the same link the Integrations page uses. */
export const AuthoriseTikTokAdsButton = ({ onClick }: AuthoriseTikTokAdsButtonProps) => {
  const { data } = useTikTokAdsAuthUrl();

  const handleClick = (event: MouseEvent) => {
    onClick?.(event);
    if (!data?.authUrl) error("TikTok Ads API is not configured. Please contact support.");
  };

  return (
    <Button
      color="primary"
      size="md"
      iconLeading={Zap}
      href={data?.authUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      Authorise TikTok ads
    </Button>
  );
};
